<div style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "> <img style="
          width: 13.35vw;
          height: auto;
        " [src]="logoUrl">
  <div class="mainloader"></div>
</div>
